module.exports = __webpack_public_path__ + "static/media/valentine_day.30ab458e.png";